export default "__VITE_ASSET__DjcFkFKg__"